export { default } from './CommentsFromUser';



// WEBPACK FOOTER //
// ./src/components/Comment/CommentsFromUserList/index.js